'use client';

import { Footer, Header } from '@/widgets';
import { ImpersonationBanner } from '@/widgets/ImpersonationBanner';
import { Container, Main } from '@/layouts/Providers/styled';
import { FooterTabsProvider } from '@/widgets/FooterLinkBox/FooterTabsContext';
import { FooterLinkBoxSwitcher } from '@/widgets/FooterLinkBox/FooterLinkBoxSwitcher';
import { ToastContainer } from 'react-toastify';

type LocaleChromeProps = {
  children: React.ReactNode;
  footerSlot: React.ReactNode;
};

export const LocaleChrome = ({ children, footerSlot }: LocaleChromeProps) => {
  return (
    <FooterTabsProvider>
      <Container>
        <Header />
        <ImpersonationBanner />
        <Main>{children}</Main>
        <FooterLinkBoxSwitcher serverSlot={footerSlot} />
        <Footer />
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        theme="light"
      />
    </FooterTabsProvider>
  );
};
